import { useCallback, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { logoutAccount } from '../actions/logout';

const SAVE_INTERVAL_MS = 1000; // 1 second
const STORAGE_KEY = 'IWK_AUTO_LOGOUT'; // Same as admin site
const EVENTS_TO_MONITOR = [
  'click',
  'keypress',
  'load',
  'mousedown',
  'mousemove',
  'scroll'
];

const useAutoLogout = (loggedIn, token, history, timeoutMinutes) => {
  const dispatch = useDispatch();

  const getLastUpdate = () => parseInt(localStorage.getItem(STORAGE_KEY)) || 0;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const setLastUpdate = useCallback(() => {
    // Only update local storage if at minimum seconds have passed
    // since we don't want to be saving every millisecond
    const timestamp = Date.now();
    const lastUpdate = getLastUpdate();

    if (timestamp - lastUpdate > SAVE_INTERVAL_MS) {
      localStorage.setItem(STORAGE_KEY, timestamp);
    }
  });

  // Logout user and redirect
  const logoutAndClose = useCallback(() => {
    const { dispatchLogout } = bindActionCreators(
      {
        dispatchLogout: logoutAccount
      },
      dispatch
    );
    dispatchLogout(token);
    history.push('/timed-out');
  }, [dispatch, history, token]);

  // Setup event listeners
  useEffect(() => {
    // If user is logged in, begin listening for activity
    if (loggedIn) {
      EVENTS_TO_MONITOR.forEach(event =>
        window.addEventListener(event, setLastUpdate)
      );
    }

    return () => {
      EVENTS_TO_MONITOR.forEach(event =>
        window.removeEventListener(event, setLastUpdate)
      );
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn]);

  // Check for user activity every second
  // If none in the last timeoutValue minutes, log them out
  useEffect(() => {
    if (loggedIn && timeoutMinutes) {
      const interval = setInterval(() => {
        const lastUpdate = getLastUpdate();
        const timeoutMS = timeoutMinutes * 60000;

        if (lastUpdate !== 0 && Date.now() - lastUpdate > timeoutMS) {
          logoutAndClose();
        }
      }, SAVE_INTERVAL_MS);

      return () => {
        clearInterval(interval);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn, timeoutMinutes]);
};

export default useAutoLogout;



// WEBPACK FOOTER //
// ./src/hooks/useAutoLogout.js